export interface Work {
  id: string;
  title: string;
  category: string;
  contestant: string;
  cover: string;
  summary: string;
  views: number;
  likes: number;
  heat: number;
  rank: number;
  publishedAt: string;
  tags: string[];
  content: string[];
}

export const categories = [
  { id: 'quannei', name: '圈内爆料', desc: '一线目击者的第一手讲述', count: 42 },
  { id: 'shendu', name: '深度盘点', desc: '把来龙去脉一次理清的长文', count: 31 },
  { id: 'xianchang', name: '现场直击', desc: '活动、后台、路演的现场记录', count: 27 },
  { id: 'fancha', name: '反差名场面', desc: '台前幕后落差最大的瞬间', count: 24 },
  { id: 'muhou', name: '幕后花絮', desc: '没被剪进正片的边角料', count: 19 },
];

export const works: Work[] = [
  {
    id: 'w-01',
    title: '直播翻车名场面三分钟回顾：从口误到全网名梗',
    category: '反差名场面',
    contestant: '夜航船',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-01&orientation=landscape',
    summary: '把当晚直播里最出圈的几次口误按时间顺序剪在一起，配上逐句还原的幕后说明，解释这个梗是怎么一步步扩散成全网模仿的。',
    views: 128400,
    likes: 9820,
    heat: 98,
    rank: 1,
    publishedAt: '2026-09-08',
    tags: ['直播现场', '名场面', '时间线'],
    content: [
      '这期作品把整场直播拆成了六个节点：开场寒暄、连麦互动、抽奖环节、临时换歌、设备故障和结尾道歉。作者逐帧标记了每一处口误发生的具体秒数，并附上当时的弹幕风向截图，让围观的人不用翻完整场回放也能看懂事情是怎么失控的。',
      '比较有意思的是第三段。原本只是一次普通的串词，因为嘉宾临场改词，主播接话时把两个品牌名念反了。弹幕先是刷了十几秒问号，随后有人在评论区补了正确的合作顺序，节奏才慢慢被带了回来。作者把这两波弹幕做了对比，能明显看出观众注意力转移的路径。',
      '作品后半段整理了这次口误被二次创作的几种形态：表情包、配乐剪辑、方言翻唱。作者没有下任何结论，只是把数据摊开——四十八小时内相关话题的搜索曲线，恰好和几个大号转发的时间点重合。想了解名场面是怎么一步步出圈的，这一篇基本够用了。',
    ],
  },
  {
    id: 'w-02',
    title: '选秀后台录音流出？一份时间线把前因后果理清楚',
    category: '深度盘点',
    contestant: '雾里看花',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-02&orientation=landscape',
    summary: '围绕一段后台录音，作者按小时还原了当天的行程、参与人员和场地调度，把能对上的信息与无法证实的内容分开罗列。',
    views: 96500,
    likes: 7420,
    heat: 94,
    rank: 2,
    publishedAt: '2026-09-07',
    tags: ['选秀', '后台', '时间线'],
    content: [
      '作品开篇先声明了信息来源的层级：公开行程、工作人员口述、粉丝拍摄画面，三类信息分别用不同标记区分。作者反复强调，录音本身没有经过专业鉴定，只能当作线索而不是结论，这一点在评论区也被多次引用。',
      '第二部分是当天的时间轴。从上午彩排到凌晨收工，作者标注了每一次人员变动和场地切换，并对比了三个不同来源的行程版本，指出其中两处对不上的地方。这种把矛盾点直接摆出来的写法，比单方面下判断更耐看。',
      '收尾部分作者列了一份待核清单，把暂时无法确认的六个问题留给读者讨论。整篇作品没有使用夸张标题，节奏偏冷静，适合想自己判断而不是被牵着走的围观者。',
    ],
  },
  {
    id: 'w-03',
    title: '商务报价单疑云：同一场活动出现两份价目表',
    category: '圈内爆料',
    contestant: '铜雀台',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-03&orientation=landscape',
    summary: '两张流传在行业群里的报价截图，数字差了将近一倍。作者没有猜测动机，只是把两份报价的条目逐项对齐并标注差异。',
    views: 88100,
    likes: 6130,
    heat: 91,
    rank: 3,
    publishedAt: '2026-09-06',
    tags: ['商务合作', '报价', '对比'],
    content: [
      '作者把两份报价单做成了对照表格，逐条列出差旅、妆造、时长、版权授权等常见条目。有意思的是，两份文件里只有「版权授权」这一项是完全一致的，其余条目都存在不同程度的浮动。',
      '中段作者补充了行业背景：同类活动在不同平台、不同地区，报价本来就有波动，因此单看差额并不能说明问题。这部分克制得不错，没有把正常浮动写成黑幕。',
      '结尾作者提出了一个更实际的观察角度——判断报价真假，与其看数字，不如看付款节点和违约条款的措辞。这个提醒对刚入行的从业者反而更有用。',
    ],
  },
  {
    id: 'w-04',
    title: '数据注水实锤合集：点赞曲线背后的异常拐点',
    category: '深度盘点',
    contestant: '拾荒者',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-04&orientation=landscape',
    summary: '作者连续跟踪了十几个账号一个月的互动数据，把凌晨时段的异常增长单独拉出来对比，做成了一张可以自己判断的曲线图。',
    views: 79200,
    likes: 5580,
    heat: 88,
    rank: 4,
    publishedAt: '2026-09-05',
    tags: ['数据观察', '曲线', '账号'],
    content: [
      '这期作品最大的特点是给了方法而不是结论。作者公开了自己的取样方式、时间窗口和判定阈值，读者完全可以照着这套流程去验证别的账号，这一点在评论区获得了不少认可。',
      '第二部分展示了正常增长和异常增长的曲线差异。前者有明显的波峰波谷，后者往往在深夜出现一条近乎笔直的上升线。作者特别说明，节假日和突发热点也会造成类似波形，需要结合内容发布时间一起看。',
      '最后作者提醒，数据异常不等于人为操作，也可能是平台推荐机制的阶段调整。把可能性列全，而不是急着盖棺定论，是这篇作品比较成熟的地方。',
    ],
  },
  {
    id: 'w-05',
    title: '综艺剪辑之争：被删掉的七分钟到底拍了什么',
    category: '现场直击',
    contestant: '白夜行',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-05&orientation=landscape',
    summary: '根据现场观众的座位视角和零散回忆，作者尝试还原正片中被剪掉的七分钟，并对比了播出前后的流程变化。',
    views: 71300,
    likes: 4960,
    heat: 85,
    rank: 5,
    publishedAt: '2026-09-04',
    tags: ['综艺', '剪辑', '现场'],
    content: [
      '作者收集了不同座位的观众回忆，把能相互印证的部分先固定下来，再处理有出入的细节。这种方法让还原结果不至于变成一个人的想象，虽然仍有不少空白，但可信度更高。',
      '中段作者对比了正片结构和现场实际顺序，指出节目组为了让节奏更紧凑，把两个相隔很远的环节剪到了一起。这在综艺制作里属于常规操作，本身并不稀奇，但确实会让观众产生错位感。',
      '结尾作者把注意力放回了内容本身：被剪掉的那部分没有争议性，只是节奏偏慢。这个判断反过来也解释了为什么最终成片会更顺。',
    ],
  },
  {
    id: 'w-06',
    title: '造型团队集体出走事件始末',
    category: '圈内爆料',
    contestant: '冷焰火',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-06&orientation=landscape',
    summary: '从近期几次活动的造型风格突变说起，作者梳理了团队更替的时间点，并附上不同阶段的风格对照。',
    views: 64800,
    likes: 4230,
    heat: 82,
    rank: 6,
    publishedAt: '2026-09-03',
    tags: ['造型', '团队', '风格'],
    content: [
      '作品从三场活动的红毯造型切入，指出妆容思路在两周内发生了明显转向。作者没有直接点名，而是把风格变化和公开的人员动态并置，让读者自己去对应时间点。',
      '第二部分整理了团队更替可能带来的实际影响：妆发周期、试装次数、服装来源都会随之调整。作者引用了业内对外的公开说明，把流程层面的变化讲得比较清楚。',
      '最后作者补了一句比较中肯的话：风格变化未必是坏事，换团队之后反而更贴合本人气质的情况也很常见。这种不带情绪的收尾，让整篇作品读起来不那么像挑事。',
    ],
  },
  {
    id: 'w-07',
    title: '一首歌两个版本：原demo与最终成品的差异盘点',
    category: '深度盘点',
    contestant: '青灯客',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-07&orientation=landscape',
    summary: '作者把网上流传的 demo 和正式发行版本做了逐段比对，从编曲、和声到人声处理，列出了一份差异清单。',
    views: 58900,
    likes: 3870,
    heat: 79,
    rank: 7,
    publishedAt: '2026-09-02',
    tags: ['音乐', '编曲', '对比'],
    content: [
      '这是一篇偏专业向的作品。作者第一段就说明自己不是从业者，只做听感层面的记录，所有判断都附上了具体时间code，方便读者对照试听。',
      '比对主要集中在三处：前奏长度、副歌和声层次、以及最后一段的人声空间感。作者用词比较克制，反复出现「可能是」「就听感而言」这类限定语，避免了过度断言。',
      '文末作者放了一张自制对照表，把差异点按「确定」「存疑」「听不出」三类归档。对喜欢研究制作细节的读者来说，这张表比正文更有价值。',
    ],
  },
  {
    id: 'w-08',
    title: '群聊截图时间线整理：谁先说了那句话',
    category: '圈内爆料',
    contestant: '半糖去冰',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-08&orientation=landscape',
    summary: '在大量截图里，作者只保留了带有明确时间戳的部分，重新排成一条顺序清晰的时间线，并标出无法核实的位置。',
    views: 52600,
    likes: 3410,
    heat: 76,
    rank: 8,
    publishedAt: '2026-09-01',
    tags: ['截图', '时间线', '核实'],
    content: [
      '流传的截图往往顺序混乱，作者做的事情很朴素：把有完整时间戳的挑出来，按时间重排，缺时间戳的单独放在文末。仅这一步，就解决了很多误读。',
      '重排之后，事件的先后关系变得清晰了不少。作者指出，有两张被广泛转发的截图实际上晚于争议发生，因此把它们当作起因并不成立。这个细节纠正了不少读者此前的印象。',
      '作者在结尾强调，截图本身容易被拼接，建议只看能对上原始出处的部分。整篇作品的语气偏取证，而不是煽动。',
    ],
  },
  {
    id: 'w-09',
    title: '颁奖夜冷场细节复盘：镜头之外发生了什么',
    category: '现场直击',
    contestant: '远山雾',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-09&orientation=landscape',
    summary: '一段被剪掉的直播画面引发猜测，作者结合现场流程表和导播习惯，解释了冷场那几秒的真实原因。',
    views: 47100,
    likes: 2960,
    heat: 73,
    rank: 9,
    publishedAt: '2026-08-31',
    tags: ['颁奖礼', '直播', '导播'],
    content: [
      '作者先说明了一个容易被忽略的前提：大型直播都有延时缓冲，观众看到的画面未必是实时发生的。理解了这一点，很多「冷场」其实只是切换节奏问题。',
      '接着作者对照了当晚的流程表，指出冷场正好发生在一个临时替换的颁奖环节。导播需要时间调整机位，画面看起来就停顿了几秒。这属于技术层面的正常波动。',
      '作者最后把这段材料和其他几次类似情况放在一起对比，得出了一个大致的结论：绝大多数直播停顿，原因都写在流程表里，只是观众看不到那张表而已。',
    ],
  },
  {
    id: 'w-10',
    title: '代言解约风波全记录：从热搜到工作室声明',
    category: '深度盘点',
    contestant: '无名氏',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-10&orientation=landscape',
    summary: '把整起风波拆成品牌方、艺人方、粉丝方三条线，分别整理各方公开表态的时间与措辞变化。',
    views: 41500,
    likes: 2540,
    heat: 70,
    rank: 10,
    publishedAt: '2026-08-30',
    tags: ['代言', '声明', '公关'],
    content: [
      '作者把事件拆成三条互不干扰的线，分别标注了信息来源和时间。这种分线写法让原本纠缠在一起的争议一下子清楚了很多。',
      '对比各方措辞的变化是这篇的重点。作者注意到，品牌方早期的公告用词很含糊，直到第二次声明才明确表述，中间的间隔恰好与热搜持续时间吻合。作者只是陈述时间关系，没有断言因果。',
      '结尾作者列出了一些理性看待此类事件的角度，比如合同期限、行业惯例等，提醒读者不要把商业决策简单理解成情感表态。',
    ],
  },
  {
    id: 'w-11',
    title: '练习生淘汰名单泄露事件：信息源头追踪',
    category: '幕后花絮',
    contestant: '夜航船',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-11&orientation=landscape',
    summary: '一份疑似名单在多个平台同步流传，作者通过发布时间差和排版特征，尝试找到最早出现的那一条。',
    views: 36800,
    likes: 2170,
    heat: 66,
    rank: 11,
    publishedAt: '2026-08-29',
    tags: ['练习生', '名单', '追踪'],
    content: [
      '作者的方法比较有意思：把各平台出现该名单的时间排成一行，最早的往往字数最少、错别字最多，后者则越传越完整。顺着这条规律，基本能判断出传播链条的方向。',
      '排版特征也被作者用上了。原图使用的表格线样式比较特别，后续转发版本大多保留了同样的边框，说明它们来自同一张源图，而不是各自独立整理。',
      '作者最后提醒，名单真假无法通过传播链判断，只能说清它是从哪来的。这个区分很重要，避免了把「找到源头」误当成「证实内容」。',
    ],
  },
  {
    id: 'w-12',
    title: '深夜番外篇：那些没被剪进正片的互动',
    category: '幕后花絮',
    contestant: '雾里看花',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20cinematic%20editorial%20abstract%20collage%2C%20crumpled%20paper%20texture%2C%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=800&height=600&seq=work-12&orientation=landscape',
    summary: '收工之后的花絮往往更松弛。作者整理了休息室、返场和散场时被拍到的片段，拼出一条轻松的番外时间线。',
    views: 31200,
    likes: 1890,
    heat: 62,
    rank: 12,
    publishedAt: '2026-08-28',
    tags: ['花絮', '休息室', '轻松'],
    content: [
      '相比前几期，这篇的基调明显轻松。作者挑选的都是没有争议的片段：后台分零食、返场前互相打气、散场时帮忙搬道具。这些画面里反而更容易看到真实的相处状态。',
      '作者按场地分区整理了素材，标注了每段画面的拍摄位置。同一间休息室的多个片段被放在一起，能看出不同嘉宾进场时间与互动对象的对应关系。',
      '整篇作品没有爆料意图，更像是给追完整季的观众留的一份纪念。作者在结尾写道，比赛之外的部分，往往才是一段记录最耐看的地方。',
    ],
  },
];